import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackAffiliateClick, getAffiliateCookie } from '@/lib/affiliate-tracker';

/**
 * Component to track affiliate clicks on initial page load and route changes
 */
export function AffiliateTracker() {
  const location = useLocation();

  useEffect(() => {
    // Parse URL parameters
    const searchParams = new URLSearchParams(location.search);
    const affiliateCode = searchParams.get('ref');

    if (affiliateCode) {
      // Track the click
      trackAffiliateClick({
        affiliateCode,
        referrerUrl: document.referrer,
        landingPage: window.location.href
      }).then(() => {
        // Remove the ref parameter from URL to clean it up
        // This prevents re-tracking if user refreshes
        const newSearchParams = new URLSearchParams(location.search);
        newSearchParams.delete('ref');
        const newSearch = newSearchParams.toString();
        const newUrl = `${location.pathname}${newSearch ? '?' + newSearch : ''}${location.hash}`;

        // Update URL without triggering navigation
        window.history.replaceState({}, '', newUrl);
      });
    }
  }, [location]);

  // This component doesn't render anything
  return null;
}